import { render, staticRenderFns } from "./orderListMobile.vue?vue&type=template&id=d4dc2c34&scoped=true"
import script from "./orderListMobile.vue?vue&type=script&lang=js"
export * from "./orderListMobile.vue?vue&type=script&lang=js"
import style0 from "./orderListMobile.vue?vue&type=style&index=0&id=d4dc2c34&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4dc2c34",
  null
  
)

export default component.exports